import { render, staticRenderFns } from "./ButtonDropdownItem.vue?vue&type=template&id=d46d1e4e&scoped=true&"
import script from "./ButtonDropdownItem.vue?vue&type=script&lang=js&"
export * from "./ButtonDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./ButtonDropdownItem.vue?vue&type=style&index=0&id=d46d1e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46d1e4e",
  null
  
)

export default component.exports